module.exports = __webpack_public_path__ + "img/b3.ddc89277.png";